import { render, staticRenderFns } from "./DebugMenu.vue?vue&type=template&id=667d72ee&scoped=true&lang=html&"
import script from "./DebugMenu.vue?vue&type=script&lang=js&"
export * from "./DebugMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667d72ee",
  null
  
)

export default component.exports